import { render, staticRenderFns } from "./identifyDialog.vue?vue&type=template&id=373c04ca&scoped=true"
import script from "./identifyDialog.vue?vue&type=script&lang=js"
export * from "./identifyDialog.vue?vue&type=script&lang=js"
import style0 from "./identifyDialog.vue?vue&type=style&index=0&id=373c04ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373c04ca",
  null
  
)

export default component.exports